import { ArrowUpOutlined, LoadingOutlined } from "@ant-design/icons";

import * as theme from "./AIPromptInput.css";

interface AIPromptInputButtonProps {
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
    ariaLabel?: string;
}

export function AIPromptInputButton({
    onClick,
    disabled = false,
    loading = false,
    ariaLabel = "Submit",
}: AIPromptInputButtonProps) {
    return (
        <button
            type="button"
            className={theme.submitButton}
            onClick={onClick}
            disabled={disabled}
            aria-label={ariaLabel}
        >
            {loading ? <LoadingOutlined spin /> : <ArrowUpOutlined />}
        </button>
    );
}
